import {
  addNodeConfigurations,
  removeNodeConfiguration,
  removeNodeConfigurations,
  resetCanvas,
  loadNodeConfigurations,
  setScenarioMetaData,
} from '../../routines/scenarios/scenarioCanvasRoutines';

const initialState = {
  scenarioInstance: null,
  nodeConfigurations: {},
  scenarioLevel: null,
  scenarioName: null,
  scenarioDescription: null,
};

const scenarioCanvasReducer = (state = initialState, action) => {
  switch (action.type) {
    case addNodeConfigurations.TRIGGER: {
      const { uuid, nodeConfiguration } = action.payload;
      return {
        ...state,
        nodeConfigurations: {
          ...state.nodeConfigurations,
          [uuid]: nodeConfiguration,
        },
      };
    }
    case removeNodeConfiguration.TRIGGER: {
      const { uuid } = action.payload;
      const { [uuid]: id, ...nodeConfigurations } = state.nodeConfigurations;
      return {
        ...state,
        nodeConfigurations,
      };
    }
    case removeNodeConfigurations.TRIGGER: {
      return {
        ...state,
        nodeConfigurations: {},
      };
    }
    case loadNodeConfigurations.TRIGGER: {
      const { nodeConfigurations } = action.payload;
      return {
        ...state,
        nodeConfigurations,
      };
    }
    case resetCanvas.TRIGGER: {
      return { ...initialState };
    }
    case setScenarioMetaData.TRIGGER: {
      const { name, description, level } = action.payload;
      return {
        ...state,
        scenarioName: name,
        scenarioDescription: description,
        scenarioLevel: level,
      };
    }
    default:
      return state;
  }
};

export default scenarioCanvasReducer;
